import { confirm } from '~/utils'

export const confirmCloseAction = async (newAction = false): Promise<boolean> =>
  confirm(
    newAction ? 'Attention, une action est déjà en cours !' : 'Attention, action non confirmée !',
    newAction ? "Vous avez déjà une action en cours, vous devez l'abandonner pour en faire une nouvelle." : "Nous n'avez pas validé l'action en cours, souhaitez-vous l'abandonner ?",
    newAction ? "Abandonner l'action en cours" : "Abandonner l'action"
  )
